var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FAE1CF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#FDF1E8",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 18V24M28.6665 18V24M15.6665 17H25.6665M15.6665 17V25C15.6665 25.2652 15.7719 25.5196 15.9594 25.7071C16.1469 25.8946 16.4013 26 16.6665 26H24.6665C24.9317 26 25.1861 25.8946 25.3736 25.7071C25.5611 25.5196 25.6665 25.2652 25.6665 25V17M15.6665 17C15.6665 15.6739 16.1933 14.4021 17.131 13.4645C18.0687 12.5268 19.3404 12 20.6665 12C21.9926 12 23.2644 12.5268 24.202 13.4645C25.1397 14.4021 25.6665 15.6739 25.6665 17M16.6665 11L17.6665 13M24.6665 11L23.6665 13M17.6665 26V29M23.6665 26V29",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidReferrals);
export default __webpack_public_path__ + "static/media/androidReferrals.75b10e9e3b19070580ca1a77f88b52dd.svg";
export { ForwardRef as ReactComponent };